export const REPORTS_API_URL = '/api/reports/report/';
export const SCHEMAS_API_URL = '/api/repos/schema/';
export const RENDER_API_URL = '/api/reports/render/';
